import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const defaultIfEmpty = (source, defaultValue) => {
    async function* generator() {
        let found = false;
        for await (const value of source) {
            found = true;
            yield value;
        }
        if (!found) {
            yield defaultValue;
        }
    }
    return new BasicAsyncEnumerable(generator);
};
